export default __webpack_public_path__ + "static/media/globus.bd80445a.png";